import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class DominioService extends BaseService {
  private baseUrl = '/dominio';

  getCargos(): Observable<any> {
    return this.baseGet<any>(`${this.baseUrl}/cargo`);
  }

  getMercados(): Observable<any> {
    return this.baseGet<any>(`${this.baseUrl}/mercado`);
  }
}
